import { useHasVisited } from 'hooks/useHasVisited';
import React, { useState } from 'react';

interface AppContextType {
  handleSkillChange: (slug: string, activated: boolean) => void;
  toggleSkillView: () => void;
  setSkillView: React.Dispatch<React.SetStateAction<'list' | 'scrum'>>;
  setSkillControl: React.Dispatch<React.SetStateAction<SkillControl[]>>;
  setMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setBoxShowing: React.Dispatch<
    React.SetStateAction<{ visible: boolean; component: null }>
  >;
  setDomContentLoaded: React.Dispatch<React.SetStateAction<boolean>>;
  DOMContentLoaded: boolean;
  skillControl: SkillControl[];
  menuOpen: boolean;
  boxShowing: { visible: boolean; component: React.ReactNode };
  load_callback: () => void;
  skillView: 'list' | 'scrum';
  hasVisited: boolean;
  skillSortAsc: 'asc' | 'desc';
  setSkillSortAsc: React.Dispatch<React.SetStateAction<'asc' | 'desc'>>;
}
export const TheAppContext = React.createContext<AppContextType>();

type SkillControl = { DisplayName: string; slug: string; activated: boolean };

const initialSkills: SkillControl[] = [
  { DisplayName: 'Frontend', slug: 'frontend', activated: true },
  { DisplayName: 'Backend', slug: 'backend', activated: true },
  { DisplayName: 'AI ML', slug: 'ai_ml', activated: true },
  { DisplayName: 'Creative', slug: 'creative', activated: true },
  { DisplayName: 'Other', slug: 'other', activated: true },
];

const AppContext = ({ children }: { children: React.ReactNode }) => {
  const [DOMContentLoaded, setDomContentLoaded] = useState(false);
  const { hasVisited } = useHasVisited();
  const [skillControl, setSkillControl] =
    useState<SkillControl[]>(initialSkills);
  const [menuOpen, setMenuOpen] = useState(false);
  const [boxShowing, setBoxShowing] = useState({
    visible: false,
    component: null,
  });

  // useEffect(() => {
  //   if (typeof window !== 'undefined') {
  //     if ((menuOpen || boxShowing.visible) && typeof window !== 'undefined') {
  //       return (document.querySelector('html').style.overflow = 'hidden');
  //     }
  //     document.querySelector('html').style.overflow = 'unset';
  //   }
  // }, [menuOpen, boxShowing.visible]);

  const [skillView, setSkillView] = useState<'list' | 'scrum'>('list');
  const [skillSortAsc, setSkillSortAsc] = useState<'asc' | 'desc'>('asc');
  const load_callback = () => {
    setDomContentLoaded(true);
  };
  const toggleSkillView = () => {
    if (skillView === 'list') setSkillView('scrum');
    else setSkillView('list');
  };

  const handleSkillChange = (slug: string, activated: boolean) => {
    const allControls = [...skillControl];
    const controlToChange = allControls.find((s) => s.slug === slug)!;
    if (controlToChange) {
      controlToChange.activated = !activated;
      setSkillControl(allControls);
    }
  };

  return (
    <TheAppContext.Provider
      value={{
        handleSkillChange,
        skillControl,
        setSkillControl,
        menuOpen,
        setMenuOpen,
        boxShowing,
        setBoxShowing,
        DOMContentLoaded,
        setDomContentLoaded,
        load_callback,
        skillView,
        toggleSkillView,
        setSkillView,
        hasVisited,
        setSkillSortAsc,
        skillSortAsc,
      }}
    >
      {children}
    </TheAppContext.Provider>
  );
};

export default AppContext;
